import { Paper, Text, Title } from "@mantine/core";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  ResponsiveContainer,
} from "recharts";
import { PDFPage } from "./PDFPage";
import useReportStore from "../../../store/useReportStore";

interface CustomTooltipProps {
  active?: boolean;
  payload?: {
    payload: any;
  }[];
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <Paper w={384} p={24} radius={8} shadow="0px -20px 80px 0px #0000000a">
        <Text>{payload[0].payload.info}</Text>
      </Paper>
    );
  }

  return null;
};


const CustomLabel: React.FC<any> = ({ x, y, width, height, name }) => {
  return (
    <foreignObject
      x={x + 8}
      y={y}
      width={width}
      height={height}
      color="#fff"
      style={{ fontSize: "24px", fontWeight: "bold" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Text
          fw={700}
          size="24px"
          style={{
            color: "#fff",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {name}
        </Text>
      </div>
    </foreignObject>
  );
};

export const TopTalentsPDF = () => {
  const { report } = useReportStore();

  const talentsData = report?.talents || [];

  const data = talentsData.data.map((talent, index) => ({
    name: talent.title,
    value: talent.percentage,
    info: talentsData.explanation,
    fill:
      index % 5 === 0
        ? "#6e40e2"
        : index % 5 === 1
        ? "#05D8D2"
        : index % 5 === 2
        ? "#3A8BD9"
        : index % 5 === 3
        ? "#A64DD7"
        : "#DE57CC",
    description: talent.description,
  }));

  return (
    <PDFPage padding>
      <Title size={48} mb={8}>
        {talentsData?.mark_down ? talentsData?.mark_down.replace("##", "") : ""}
      </Title>
      <Text mb={48} size="28px" lh="42px" c="dimmed">
        {talentsData?.explanation ? talentsData?.explanation : ""}
      </Text>
      <ResponsiveContainer width="100%" height={567}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid horizontal={false} />
          <XAxis
            type="number"
            tickFormatter={(tick) => `${tick}%`}
            interval={0}
            ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
          />
          <YAxis type="category" dataKey="name" width={0} tick={false} />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="value" isAnimationActive={false} radius={[8, 8, 8, 8]}>
            <LabelList dataKey="value" content={CustomLabel} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {data.map((item, index) => (
        <Text mt={30} size="28px" lh="42px" key={index}>
          <b>{item.name}</b>: {item.description}
        </Text>
      ))}
    </PDFPage>
  );
};
